// extracted by mini-css-extract-plugin
export default {"container":"emptyActivity_container__P4Jkt"};